module.exports = __webpack_public_path__ + "static/media/impact_alert_icon.4621496d.png";